import { render, staticRenderFns } from "./HeaderButton.vue?vue&type=template&id=546b374c"
import script from "./HeaderButton.vue?vue&type=script&lang=js"
export * from "./HeaderButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports